import { render, staticRenderFns } from "./DefaultViewer.vue?vue&type=template&id=f3a3c2b2"
import script from "./DefaultViewer.vue?vue&type=script&lang=ts"
export * from "./DefaultViewer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports